import React, { Fragment } from "react";
import { SecondaryNav } from "../../../../components/AppChrome/components/SecondaryNav";
import {SiteDetailLinks} from "../../../../utils/routes/siteDetails";

export const Navigation: React.FC = () => {
  return (
    <Fragment>
      <SecondaryNav links={SiteDetailLinks} hasBottomBorder={false} />
    </Fragment>
  );
};
